export { default as default } from './KitMediaDurationIndicator';
